import React, { useState,useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Time icon
import MonitorWeightIcon from "@mui/icons-material/MonitorWeight"; // Weight icon
import StraightenIcon from "@mui/icons-material/Straighten"; // Waist icon
import InfoIcon from "@mui/icons-material/Info"; // Info icon
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import PWAHeader from "../common/PWAHeader";
import DatePickerRow from "../common/DatePickerRow";
import PrimaryButton from "../common/PrimaryButton";
import {  Delete} from '@mui/icons-material';
import { Scale } from 'lucide-react';
import './Fsn27LogWeight.css'
import {  fetchWeightData, saveWeightLogData,deleteUserWightLogEntry } from '../apiservices/ApiService';

const Fsn27LogWeight = ({ onTap }) => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [logTime, setLogTime] = useState(new Date());
  const [weight, setWeight] = useState(""); // Default weight
  const [waist, setWaist] = useState(""); // Waist circumference
  const [loggedEntries, setLoggedEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);

  useEffect(() => {
  
    // Load entries for selected date
    const fetchData = async () => {
     
      // Load entries for selected date
      try {
        const response = await fetchWeightData({
          date: selectedDate,
          dataInDepth: "1",
        });

        const data = response;
       console.log("fetchWeightData",response)
       if (data.length > 0) {
        setLoggedEntries(data);
      }
  
      } catch (error) {
        console.error("Error fetching water data:", error);
      }

      ;
    };

    fetchData();
  }, [selectedDate]);

  const formatTimestamp = (isoString) => {
    const date = new Date(isoString);
    const options = { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleString('en-US', options).replace(',', '');
  };
  const handleSubmit = async () => {
   
    console.log("handleSubmit");
    const getCurrentTimeInSeconds = () => {
      const now = new Date();
      return Math.floor(now.getTime() / 1000); // Convert milliseconds to seconds
    };
    const getCurrentTime = () => {
      const now = new Date();
  
      // Format date and time
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Get month (0-based index)
      const day = String(now.getDate()).padStart(2, '0'); // Get day
      const hours = String(now.getHours()).padStart(2, '0'); // Get hours
      const minutes = String(now.getMinutes()).padStart(2, '0'); // Get minutes
      const seconds = String(now.getSeconds()).padStart(2, '0'); // Get seconds
  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const handleLog = async (e) => {
    
      try {
  
        let payload = JSON.stringify(
          [{"weight":weight,"source":"goqii","moisture":"0","weightUnit":"KG","serverWeightId":"-1","status":"new","visceralFat":"0","waist":waist,"bodyFat":"0","resistance":"0","createdTime":getCurrentTime(),"date":`${selectedDate}`,"bmr":"0","bmi":"0","protein":"0","skeletalMuscle":"0","localWeightId":`${getCurrentTimeInSeconds()}`,"bone":"0","targetWeight":"0","boneMuscle":"0","hip":"0"}]
   
        )
        const response = await saveWeightLogData({ data: payload });
  
        console.log("weitght/add_wewight API response:", response);
        console.log(payload.createdTime)
        const response1 = await fetchWeightData({
          date: selectedDate,
          dataInDepth: "1",
        });
       
    
        setLoggedEntries(response1);
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    }
   // Data :[{"weight":weight,"source":"goqii","moisture":"0","weightUnit":"KG","serverWeightId":"-1","status":"new","visceralFat":"0","waist":waist,"bodyFat":"0","resistance":"0","createdTime":getCurrentTime(),"date":`${selectedDate}`,"bmr":"0","bmi":"0","protein":"0","skeletalMuscle":"0","localWeightId":`${getCurrentTimeInSeconds()}`,"bone":"0","targetWeight":"0","boneMuscle":"0","hip":"0"}]
   handleLog()
  };
  const handleDeleteEntry = (id) => {
    setLoggedEntries(loggedEntries.filter(entry => entry.serverWeightId !== id));
    setSelectedEntry(null);

    const fetchData = async () => {
      const payload = JSON.stringify([
        {
          serverWeightId: id,
          status: "old",
          source: "GOQii",
          date: `${selectedDate}`,
        },
      ]);

      const deletedResponse = await deleteUserWightLogEntry({ data: payload });

      const response1 = await fetchWeightData({
        date: selectedDate,
        dataInDepth: "1",
      });
     
  
      setLoggedEntries(response1);
    }
    fetchData()
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ padding: "16px" }}>
        <PWAHeader title={onTap?.FAI?.title || "Log Weight"} />
        <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          restrictPastDates={false}  // Restrict past dates for appointment booking
          restrictFutureDates={true} // Allow future dates
        />

        {/* Log Time */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <AccessTimeIcon sx={{ marginRight: "8px", color: "#4CAF50" }} />
            <Typography variant="body1">Time</Typography>
          </Box>
          <TimePicker
            value={logTime}
            onChange={(newTime) => setLogTime(newTime)}
            renderInput={(params) => <TextField {...params} sx={{ width: "100px", textAlign: "center" }} />}
          />
        </Box>

        {/* Weight */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <MonitorWeightIcon sx={{ marginRight: "8px", color: "#4CAF50" }} />
            <Typography variant="body1">Weight</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              type="number"
              inputProps={{ min: 0 }}
              sx={{ width: "80px", textAlign: "center" }}
                placeholder="--"
            />
            <Typography variant="body2" sx={{ marginLeft: "8px" }}>
              kg
            </Typography>
            <IconButton>
              <InfoIcon sx={{ color: "#BDBDBD" }} />
            </IconButton>
          </Box>
        </Box>

        {/* Waist */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <StraightenIcon sx={{ marginRight: "8px", color: "#4CAF50" }} />
            <Typography variant="body1">Waist</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              value={waist}
              onChange={(e) => setWaist(e.target.value)}
              type="number"
              inputProps={{ min: 0 }}
              sx={{ width: "80px", textAlign: "center" }}
              placeholder="--"
            />
            <Typography variant="body2" sx={{ marginLeft: "8px" }}>
              cm
            </Typography>
            <IconButton>
              <InfoIcon sx={{ color: "#BDBDBD" }} />
            </IconButton>
          </Box>
        </Box>

        {/* Log Button */}
        <PrimaryButton onClick={handleSubmit} label="Log" />
      </Box>
     < div className="logged-entries-section">
        <div className="section-title">Logged Weight</div>
        <div className="entries-list">
          {loggedEntries
            .filter(entry => entry.date === selectedDate)
            .map((entry) => (
              <div
                key={entry.serverWeightId}
                className="entry-item"
                onTouchStart={() => {
                  const timer = setTimeout(() => {
                    setSelectedEntry(entry.serverWeightId);
                  }, 2);
                  return () => clearTimeout(timer);
                }}
              >
                <div className="entry-content">
                  <Scale className="water-drop-icon" />
                  <div className="entry-details">
                    <div className="entry-title">Weight</div>
                    <div className="entry-amount">{entry.weight} Kg</div>
                  </div>
                </div>
                <div className="entry-content">
                  {/* <FitnessCenterIcon className="water-drop-icon" /> */}
                  <div className="entry-details">
                    <div className="entry-title">Waist</div>
                    <div className="entry-amount">{entry.waist} Cm</div>
                  </div>
                </div>
                <div className="timestamp-container">
              
                  <div className="timestamp-label">Logged at</div>
                  <div className="timestamp-value">
                    {formatTimestamp(entry.createdTime)}
                  </div>
                </div>
                {selectedEntry === entry.serverWeightId && (
                  <button
                   onClick={() => handleDeleteEntry(entry.serverWeightId)}
                    className="delete-button"
                  >
                    <Delete />
                  </button>
                )}
              </div>
            ))}
        </div>
        </div>
     
    </LocalizationProvider>
  );
};

export default Fsn27LogWeight;